
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/madurai",
      function () {
        return require("private-next-pages/madurai/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/madurai"])
      });
    }
  